// 审批单状态字典
export const approvalStatusDic = [
  { label: "审批中", value: "PENDING" },
  { label: "全部通过", value: "APPROVED" },
  { label: "已驳回", value: "REJECTED" },
  { label: "已撤销", value: "CANCELLED" },
  { label: "申请失败", value: "APPLY_FAILED" },
];

// 节点状态字典
export const approvalNodeStatusDic = [
  { label: "待开始", value: "WAITING" },
  { label: "审批中", value: "PENDING" },
  { label: "已通过", value: "APPROVED" },
  { label: "已驳回", value: "REJECTED" },
  { label: "已跳过", value: "SKIPPED" },
];

// 操作类型字典（明细 action）
export const approvalActionDic = [
  { label: "新增", value: "ADD" },
  { label: "改价", value: "UPDATE" },
  { label: "删除", value: "DELETE" },
];

// 审批业务类型字典
export const approvalBusinessTypeDic = [
  { label: "商户价调整", value: "PRICE_BOOK_MERCHANT_ADJUST" },
];

// 审批中心 - 待我审批表格配置
export const approvalTodoTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  stripe: true,
  index: true,
  indexLabel: "序号",
  menu: true,
  menuWidth: 120,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuType: "text",
  column: [
    {
      label: "审批标题",
      prop: "title",
      search: true,
      searchPlaceholder: "请输入标题关键词",
      minWidth: 220,
    },
    {
      label: "状态",
      prop: "status",
      type: "select",
      dicData: approvalStatusDic,
      search: true,
      slot: true,
      width: 100,
    },
    {
      label: "发起人",
      prop: "applicantName",
      minWidth: 100,
    },
    {
      label: "当前节点",
      prop: "currentNodeOrder",
      slot: true,
      width: 110,
    },
    {
      label: "提交时间",
      prop: "submitTime",
      slot: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 160,
    },
  ],
};

// 审批中心 - 我已审批表格配置
export const approvalDoneTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  stripe: true,
  index: true,
  indexLabel: "序号",
  menu: true,
  menuWidth: 120,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuType: "text",
  column: [
    {
      label: "审批标题",
      prop: "title",
      search: true,
      searchPlaceholder: "请输入标题关键词",
      minWidth: 220,
    },
    {
      label: "状态",
      prop: "status",
      type: "select",
      dicData: approvalStatusDic,
      search: true,
      slot: true,
      width: 100,
    },
    {
      label: "发起人",
      prop: "applicantName",
      minWidth: 100,
    },
    {
      label: "提交时间",
      prop: "submitTime",
      slot: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 160,
    },
    {
      label: "审批完成时间",
      prop: "finishTime",
      slot: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 160,
    },
  ],
};

// 审批中心 - 我发起的表格配置
export const approvalMineTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  stripe: true,
  index: true,
  indexLabel: "序号",
  menu: true,
  menuWidth: 120,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuType: "text",
  column: [
    {
      label: "审批标题",
      prop: "title",
      search: true,
      searchPlaceholder: "请输入标题关键词",
      minWidth: 220,
    },
    {
      label: "状态",
      prop: "status",
      type: "select",
      dicData: approvalStatusDic,
      search: true,
      slot: true,
      width: 100,
    },
    {
      label: "当前节点",
      prop: "currentNodeOrder",
      slot: true,
      width: 110,
    },
    {
      label: "提交时间",
      prop: "submitTime",
      slot: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 160,
    },
    {
      label: "完成时间",
      prop: "finishTime",
      slot: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      width: 160,
    },
  ],
};
